import { createNavigation } from 'next-intl/navigation';

import { routing } from './routing';

/**
 * next-intl'in HAM bağlantıları — locale önekini ekleyenler.
 *
 * 🔴 Bileşenler bunu DEĞİL `@/i18n/navigation`ı kullanır. Oradaki sarmalayıcı
 * bir şey daha yapıyor: panel adreslerine etkin çalışma alanı segmentini
 * ekliyor (`/dashboard/campaigns` → `/dashboard/w/blesyum/campaigns`).
 * Buradan doğrudan import eden bir bağlantı, kullanıcıyı alan seçimi
 * eşiğine düşürür ve fazladan bir yönlendirme turu doğurur.
 *
 * Ayrı dosya olmasının sebebi kapsam: sarmalayıcı istemci bileşeni
 * ('use client') ve bu modül hem sunucuda hem istemcide okunabilir kalmalı.
 */
export const {
  Link: IntlLink,
  redirect: intlRedirect,
  usePathname: useIntlPathname,
  useRouter: useIntlRouter,
  getPathname: getIntlPathname,
} = createNavigation(routing);
